import type { SystemStatus } from '../types/system-status.dto';
import type { SystemStatusModel } from '../types/system-status.model';

export const toSystemStatusModel = (dto: SystemStatus): SystemStatusModel => {
	return {
		parentId: dto.parent_id,
		organizationId: dto.organization_id,
		name: dto.name,
		timeZone: dto.time_zone,
		city: dto.city,
		country: dto.country,
		devices: {
			total: dto.devices.total,
			connected: dto.devices.connected,
			disconnected: dto.devices.disconnected,
			devices: dto.devices.devices.map((device) => ({
				id: device.id,
				type: device.type,
				name: device.name,
				isConnected: device.is_connected,
			})),
		},
		users: {
			total: dto.users.total,
			online: dto.users.online,
			offline: dto.users.offline,
			users: dto.users.users.map((user) => ({
				id: user.id,
				fullName: user.full_name,
				isOnline: user.is_online,
			})),
		},
		createdTime: dto.created_time,
		modifiedTime: dto.modified_time,
	};
};
